import {
  displayError,
  displaySuccess,
  displayWarning,
} from "../../utils/messageToast";
import { arrayCSV } from "../../utils/functionsInterfaces";
import { SetupAuth } from "../../client";

export const createSkills = async (
  ambient: string,
  authorization: string,
  namesData: arrayCSV[],
  setTextAreaValue: React.Dispatch<React.SetStateAction<string>>,
  setIsErrors: React.Dispatch<React.SetStateAction<boolean>>,
  setErrors: React.Dispatch<React.SetStateAction<any[]>>,
  inForce: boolean
) => {
  try {
    const apiClient = SetupAuth(authorization);
    const response = await apiClient.post(
      `/create-skills?ambient=${ambient}&isInForce=${inForce}`,
      namesData
    );
    if (response.data.errors.length > 0) {
      displayWarning("Algumas habilidades não foram criadas!");
      setTextAreaValue(JSON.stringify(response.data.skillCreated, null, 2));
      setIsErrors(true);
      setErrors(response.data.errors);

      return;
    } else {
      displaySuccess("Habilidades criadas com sucesso!");
      setTextAreaValue(JSON.stringify(response.data.skillCreated, null, 2));
      setIsErrors(false);
      setErrors([]);

      return;
    }
  } catch (error: any) {
    displayError("Erro ao criar habilidades!");
    return;
  }
};